import { render, staticRenderFns } from "./InsuranceApplyForm.vue?vue&type=template&id=08238cc4&scoped=true&"
import script from "./InsuranceApplyForm.vue?vue&type=script&lang=js&"
export * from "./InsuranceApplyForm.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceApplyForm.vue?vue&type=style&index=0&id=08238cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08238cc4",
  null
  
)

export default component.exports